export const MAX_AMOUNT_OF_ARTICLES = 6;
export const POSTS_PER_PAGE = 12;
export const SEARCH_POSTS_PER_PAGE = 12;
